import { memo } from 'react';
import './error-message.css';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorMessage = memo(function ErrorMessage({
  message,
  onRetry,
}: ErrorMessageProps) {
  return (
    <div className="error-message-container" role="alert">
      <span className="material-symbols-outlined error-message-icon" aria-hidden="true">
        error_outline
      </span>
      <p className="error-message-text">{message}</p>
      {onRetry && (
        <button type="button" className="error-message-retry-btn" onClick={onRetry}>
          <span className="material-symbols-outlined" aria-hidden="true">refresh</span>
          Try again
        </button>
      )}
    </div>
  );
});

export default ErrorMessage;
